<script>
import baseList from "@/views/components/base/baseList.vue";
export default {
  extends: baseList,
  data() {
    return {
      table: {
        mname: "",
        url: {
          list: "/admin/system/meeting/sign/list",
        },
        output: false,
      },
      menus: [
        {
          label: "签到表",
          name: "Qiandaobiao",
          auth: "system/Qiandaobiao/index",
        },
        {
          label: "出勤率",
          name: "Attendance",
          auth: "system/Attendance/index",
        },
      ],
      filters: [
        {
          label: "签到时间",
          KeyEnter: this.search,
          name: "signTime",
          value: "",
          type: "contractdatetimerange",
        },
        {
          label: "主题",
          KeyEnter: this.search,
          name: "meetingName",
          value: "",
          type: "input",
        },
      ],
      tableCols: [
        {
          title: "序号",
          type: "index",
          width: 80,
          align: "center",
        },
        {
          title: "会议主题",
          minWidth: 300,
          align: "left",
          key: "meetingName",
        },
        {
          title: "姓名",
          minWidth: 200,
          align: "left",
          render: (h, p) => {
            let item = p.row.deskName ? p.row.deskName : "";
            let item2 = p.row.signUserName;
            return h('div', [
              h('span', {
                style: {
                  display: 'inline-block',
                  width: '100%',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                },
                domProps: {
                  title: (item ? item + "-" : "") + item2
                }
              }, (item ? item + "-" : "") + item2)
            ])
          },
        },
        {
          title: "签到时间",
          width: 180,
          align: "center",
          render: (h, p) => {
            let item = p.row.signType == 3 ? "" : p.row.signTime;
            return <div>{item}</div>;
          },
        },
        {
          title: "⼿机号",
          width: 140,
          align: "center",
          key: "phone",
        },
        {
          title: "是否应到",
          width: 100,
          align: "center",
          render: (h, p) => {
            let item = p.row.isMostCheck == 1 ? "是" : "否";
            return <div>{item}</div>;
          },
        },
        {
          title: "是否签到",
          width: 100,
          align: "center",
          render: (h, p) => {
            let item = p.row.signType != 3 ? "是" : "否";
            return <div>{item}</div>;
          },
        },
        {
          title: "是否迟到",
          width: 100,
          align: "center",
          render: (h, p) => {
            let item = p.row.signType == 2 ? "是" : p.row.signType == 3 ? "" : "否";
            return <div>{item}</div>;
          },
        },
        {
          title: "迟到时间",
          width: 140,
          align: "center",
          render: (h, p) => {
            let item = p.row.signType == 2 ? p.row.lateTime + "分钟" : "";
            return <div>{item}</div>;
          },
        },
      ],
    };
  },
  created() {},
  methods: {
    toInfo(item) {
      console.log(item);
      switch (item.infoType) {
        case 1:
          $utils.url.push({
            name: "workOrder_info",
            query: {
              action: "edit",
              kv: item.workId,
              stateId: item.id,
            },
          });
          break;
        case 2:
          $utils.url.push({
            name: "recordInfo",
            query: {
              action: "edit",
              kv: item.workId,
              stateId: item.id,
            },
          });
          break;
        case 3:
          $utils.url.push({
            name: "Info_Task",
            query: {
              action: "view",
              kv: item.workId,
              stateId: item.id,
            },
          });
          break;
        case 4:
          window.localStorage.setItem("projectId", item.workId);
          $utils.url.push({
            name: "schedule_Info",
            query: {
              stateId: item.id,
            },
          });
          break;

        default:
          break;
      }
    },
    toAdd() {
      $utils.url.push({ name: "addabsent", query: { action: "add" } });
    },
  },
};
</script>

<style></style>
